import React, { Component } from 'react';
import * as $ from 'jquery';
import axios from 'axios';
import { translate } from 'react-i18next';
import Summit from './Summit.js';

let cancelToken;

class SummitAsistenciaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitState(props);
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        $(window).off("resize", this.resize);
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }

    getInitState = (props) => {
        return {
            folio: null,
            fullname: null,
            correo: null,
            cuidad: null,
            edad: null,
            genero: null,
            empresaName: null,
            puesto: null,
            plan: null,
            estado: null,
            cuidad: null,
            isMember: this.props.user ? this.props.user.member === 3 : false
        }
    }

    reload = () => {
        const pathParts = window.location.pathname.split('/');
        const qr_code = pathParts[pathParts.length - 1];
        this.getInfoAistentes({
            token_id: this.props.getTokenId(),
            qr_code: qr_code,
        });
    }

    getInfoAistentes = (params) => {
        this.props.post(
            "/getAsistencia",
            params,
            (response) => this.didGetAsistencia(response),
            (error) => this.didGetError(error),
            cancelToken
        );
    }

    updateAsistent = (params) => {
        this.props.post(
            "/updateAsistent",
            params,
            (response) => this.didupdateAsistent(response),
            (error) => this.didGetError(error),
            cancelToken
        );
    }

    handleSummit = (event) => {
        event.preventDefault();
        const pathParts = window.location.pathname.split('/');
        const qr_code = pathParts[pathParts.length - 1];
        this.updateAsistent({
            token_id: this.props.getTokenId(),
            qr_code: qr_code,
        });

    }

    didupdateAsistent = (response) => {
        alert('Asistencia Resgistrada ');
    }

    didGetAsistencia = (response) => {
        if (response) {
            if (response.asistencia == 'Realizada') {
                alert('Usuario Registro Asitencia')
                this.setState({
                    isMember: false
                })
            }
            this.setState({
                folio: response.id ? response.id : null,
                fullname: response.nombre,
                correo: response.correo,
                cuidad: response.cuidad,
                genero: response.genero,
                empresaName: response.empresa,
                puesto: response.puesto,
                plan: response.plan,
                edad: response.edad,
                estado: response.estado_name,
                cuidad: response.cuidad_name,
            })
        } else {
            alert('No se Enonctrar Registros del Usuario')
        }
    }

    didGetError = (error) => {
        alert('No se encontro informacion del Asistentes');
    }

    renderSummit = () => {
        return (
            <div className="summit-formulario">
                <div className="panel-body summit-panel">
                    <div className="panel panel-default">
                        <div className="panel-body text-left">
                            <Summit
                                folio={this.state.folio}
                                fullname={this.state.fullname}
                                correo={this.state.correo}
                                cuidad={this.state.cuidad}
                                estado={this.state.estado}
                                edad={this.state.edad}
                                genero={this.state.genero}
                                empresaName={this.state.empresaName}
                                puesto={this.state.puesto}
                                plan={this.state.plan}
                                isMember={this.state.isMember}
                                handleSummit={this.handleSummit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return(
            <div className="store-container summit-container">
                <div className="summit-container-forms" style={{width: "100%"}}>
                    <div className="simmit-forms" style={{height: "auto"}}>
                        {this.renderSummit()}
                    </div>
                </div>
            </div>
        )
    }


}

export default translate('common')(
    SummitAsistenciaContainer
);


// WEBPACK FOOTER //
// ./src/guest/summit_asistencia/SummitAsistenciaContainer.js